module.exports = __webpack_public_path__ + "img/dataforce-block-bg-bottom.a5fac3db.svg";